import { Link } from 'react-router-dom';
import { AlertTriangle, Home } from 'lucide-react';
import SEOHead from '../components/SEOHead';
import { SITE_INFO } from '../data';

export default function NotFoundPage() {
  return (
    <>
      <SEOHead 
        title={`Side Ikke Fundet (404) - ${SITE_INFO.name}`}
        description="Siden du leder efter findes desværre ikke på vores hjemmeside."
      />

      <section className="min-h-[70vh] bg-stone-900 text-white flex items-center justify-center py-20 px-4">
        <div className="max-w-xl mx-auto text-center space-y-6">
          <div className="w-20 h-20 bg-amber-600/10 border border-amber-600/30 text-amber-500 flex items-center justify-center text-3xl mx-auto">
            <AlertTriangle className="w-9 h-9" />
          </div>

          <span className="font-heading font-black text-6xl text-amber-500 block tracking-tight">404</span>

          <h1 className="font-heading font-extrabold text-3xl sm:text-4xl text-white">
            Siden blev ikke fundet
          </h1>

          <p className="text-stone-300 text-sm sm:text-base leading-relaxed">
            Den adresse du forsøgte at tilgå findes ikke længere eller kan være flyttet. Du kan bruge knapperne herunder til at navigere tilbage til sikre områder på sitet.
          </p>

          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-amber-600 hover:bg-amber-500 text-stone-950 font-heading font-bold text-sm px-6 py-3 transition-colors"
            >
              <Home className="w-4 h-4" />
              <span>Gå Til Forsiden</span>
            </Link>
            <Link
              to="/ydelser"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-stone-800 hover:bg-stone-700 text-stone-200 font-heading font-semibold text-sm px-6 py-3 border border-stone-700 transition-colors"
            >
              <span>Se Vores Ydelser</span>
            </Link>
            <Link
              to="/kontakt"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-stone-800 hover:bg-stone-700 text-stone-200 font-heading font-semibold text-sm px-6 py-3 border border-stone-700 transition-colors"
            >
              <span>Kontakt Os</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
